<template>
    <div>
        <div class="loader" v-if="ringLoading">
            <div class="lds-ring">
                <div />
                <div />
                <div />
                <div></div>
            </div>
        </div>
        <SearchBar
            v-if="!trackandtrace_anon"
            :clientId="this.$store.state.clients.current"
            @research="research = true"
            :init-display-form="[]"
        />
        <v-layout column>
            <div v-if="$store.state.loader.loading">
                <v-skeleton-loader :loading="$store.state.loader.loading" type="table"></v-skeleton-loader>
            </div>
            <v-card v-else>
                <v-row>
                    <v-col>
                        <Tabs :customer-hu-reference="details.customerHandlingUnitReference" backButton />
                    </v-col>
                </v-row>
                <Dynamic
                    :data="{ content, details, documents, events }"
                    :service="service"
                    :type="
                        ['Details', 'Contents', 'Documents', 'Events'].includes(this.$route.query.tab)
                            ? this.$route.query.tab
                            : 'Details'
                    "
                ></Dynamic>
            </v-card>
        </v-layout>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import {
    CONTENT,
    DETAILS,
    DOCUMENTS,
    EVENTS,
    SHIPMENT,
    GET_SCOPEFLOWS_SEARCH,
    SET_CONTENT,
    SET_DETAILS,
    SET_DETAILS_REFERENCES,
    SET_DOCUMENTS,
    SET_EVENTS,
    SET_SCOPEFLOWS_SEARCH
} from '../../constants/shipment';
import { api } from '../../utils/api';

import Dynamic from '@/components/Dynamic.vue';
import SearchBar from '@/components/SearchBar';
import Tabs from '@/components/Tabs';

export default {
    components: { Dynamic, SearchBar, Tabs },
    data() {
        return {
            service: 'trackandtrace',
            research: false,
            customerHUReference: null,
            id: null,
            clientId: this.$store.state.clients.current
        };
    },
    computed: {
        ...mapState(SHIPMENT, [CONTENT, DETAILS, DOCUMENTS, EVENTS]),
        ...mapState({ ringLoading: state => state.loader.ringLoading }),
        trackandtrace_anon() {
            return this.$store.state.groups.connected && this.$store.state.groups.userRoles?.trackandtrace?.anon;
        }
    },
    methods: {
        ...mapMutations(SHIPMENT, [
            SET_CONTENT,
            SET_DETAILS,
            SET_DETAILS_REFERENCES,
            SET_DOCUMENTS,
            SET_EVENTS,
            SET_SCOPEFLOWS_SEARCH
        ]),
        ...mapMutations(['setSelectedRow', 'setIsOsol', 'setSubpageNumber', 'setLoading', 'setRingLoading']),
        ...mapGetters(SHIPMENT, [GET_SCOPEFLOWS_SEARCH]),
        getHeaderConfigId() {
            return this.$store.getters.getCurrentClientId || 'T&T_default';
        },
        async setShipments() {
            const { id, customerHUReference, clientId } = this;

            this.setLoading(true);
            this.research = false;
            try {
                const [details, detailsReferences, events, content] = await Promise.all([
                    api.get('details', null, {
                        params: {
                            serviceNumber: id,
                            customerHUReference,
                            clientId,
                            scopeflow: (this.$store.state.shipment.scopeflowsSearch || this.scopeflow)?.replace(
                                'PORTAIL_CLIENT_',
                                ''
                            )
                        }
                    }),
                    api.get(
                        ['config', 'getDetailsTabConfig'],
                        {
                            configId: this.getHeaderConfigId(),
                            scopeflow: this.getScopeflowsSearch() ? this.getScopeflowsSearch() : 'null'
                        },
                        {
                            params: { defaultConfigId: 'T&T_default' }
                        }
                    ),
                    api.get('events', null, { params: { serviceNumber: id, customerHUReference, clientId } }),
                    api.get('content', null, { params: { serviceNumber: id, customerHUReference, clientId } })
                ]);

                if (detailsReferences.logo && !!this.$route.query.osol) {
                    this.$store.commit('setClients', [
                        {
                            id: detailsReferences.id,
                            logo: detailsReferences.logo,
                            name: detailsReferences.clientName,
                            incidentEmails: detailsReferences.incidentEmails || null
                        }
                    ]);
                    this.$store.commit('setCurrent', detailsReferences.id);
                }
                this.setDetails(details);
                this.setDetailsReferences(detailsReferences);
                this.setEvents(events.events || []);
                this.setContent(content);
                this.setSubpageNumber({ subpage: 'trackandtrace.events.events', number: events?.events?.length });
                this.setSubpageNumber({ subpage: 'trackandtrace.content.content', number: content.cases?.sizing?.length });
                this.setLoading(false);

                const documents = await api.get('documents', {
                    id,
                    clientId: this.$store.getters.getCurrentClientId || detailsReferences.id,
                    osol: !!this.$route.query.osol
                });
                this.setDocuments(documents);
                this.setSubpageNumber({ subpage: 'trackandtrace.documents.documents', number: documents?.length });
            } catch (err) {
                this.setLoading(false);
            }
        }
    },
    async mounted() {
        // get URL path && query
        const urlPathName = document.location.pathname;
        const urlQuery = window.location.search;

        this.setRingLoading(true);
        if (urlPathName.includes('/OSOL/') && this.$route.query.osol) {
            await api.get(['admin', 'allowOsol']);
            const osol = this.$route.query.osol.replace(/\s/g, '+');
            const scopeflow = this.$route.query.scopeflow.replace(/\s/g, '+');
            const informations = await api.get(['admin', 'osol'], null, {
                params: { URL: osol, scopeflow: this.$route.query.scopeflow }
            });
            this.setIsOsol(true);
            if (Array.isArray(informations) && informations.length > 1) {
                this.$store.commit('storeScopeflowsResult', informations);
                this.$store.commit('setNbShipments', informations.length);
                this.setSelectedRow({});
                this.$router.push(`/${this.$store.getters.getClientName}/trackandtrace`);
                return;
            } else {
                this.id = informations.serviceNumber;
                this.clientId = informations.clientId;
                this.customerHUReference = informations.customerHandlingUnitReference;
                this.scopeflow = scopeflow;
                this.setScopeflowsSearch(scopeflow);
            }
        } else if (decodeURI(urlPathName).startsWith(`/${this.$store.getters.getClientName}/trackandtrace`)) {
            this.id = this.$route.query.id;
            this.customerHUReference = this.$route.query.churef;
        }
        await this.setShipments();

        // added to fix the problem of google analytics
        if (urlPathName.startsWith('/OSOL') && this.$route.query.osol) {
            const clientName = this.$store.getters.getClients[0].name;
            // added client Name in path and in query
            const newLocation =
                window.location.pathname.replace('/OSOL', `/${clientName}/OSOL`) + `${urlQuery}&churef=${clientName}`;
            this.$router.push(newLocation);
        }
        // stop loading
        await this.setRingLoading(false);
    },
    watch: {
        research() {
            if (this.research) {
                this.id = this.$route.query.id;
                this.customerHUReference = this.$route.query.churef;
                this.$nextTick(() => this.setShipments());
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.loader {
    margin: 50px auto;
    display: flex;
    align-items: center;
    justify-content: center;
}
.lds-ring {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid #311b92;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #311b92 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
